export const SET_SELECTION = "SELECTION_SET_SELECTION";
export const CLEAR_SELECTION = "SELECTION_CLEAR_SELECTION";
export const TOGGLE_SELECTION = "SELECTION_TOGGLE_SELECTION";

export function setSelection(context, id) {
  return {
    type: SET_SELECTION,
    context, id
  }
}

export function toggleSelection(context, id) {
  return {
    type: TOGGLE_SELECTION,
    context, id
  } 
}

export function clearSelection(context) {
  return {
    type: CLEAR_SELECTION
  }
}
